import { Button, Card, Col, Row, Table, message, Tag } from 'antd';
import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, withRouter } from 'react-router-dom';
import { fetchAllTicket } from 'redux/features/ticket';

export const TICKET = (properties) => {
	const history = useHistory()
	const dispatch = useDispatch();
	const [title, setTitle] = useState(true)
	const {
		list,
		selectedRows,
		filter: { q: searchTerm },
		loading: {
			query: loadingQuery,
			mutation: loadingMutation
		}
	} = useSelector(state => state.ticket)

	const getData = useCallback(async () => {
		try {
			await dispatch(fetchAllTicket()).unwrap()
		} catch (error) {
			message.error(error?.message || 'Failed to fetch data')
		}
	}, [dispatch])

	useEffect(() => {
		if (properties.noTitle) {
			setTitle(false)
		}
		getData()
	}, [])

	const tableColumns = [
		{
			title: 'ID',
			dataIndex: '_id',
			key: '_id',
		},
		// {
		// 	title: 'Tanggal',
		// 	dataIndex: 'tanggal',
		// 	key: 'tanggal',
		// },
		// {
		// 	title: 'Nama Pasien',
		// 	dataIndex: 'user',
		// 	render: (_, record) => {
		// 		return (
		// 			<>{record.user.namaLengkap}</>
		// 		)
		// 	},
		// },
		{
			title: 'Pertanyaan',
			dataIndex: 'question',
			key: 'question',
		},
		{
			title: 'Answer',
			dataIndex: 'answer',
			key: 'answer',
		},
		{
			title: () => <div className="text-center">Status</div>,
			key: 'status',
			render: (_, record) => (
				<div className="text-center">
					<Tag className="mr-0" color={record.answer === '' ? 'volcano' : 'green'}>{record.answer === '' ? 'PENDING' : 'CLOSED'}</Tag>
				</div>
			),
		},
		{
			title: () => <div className="text-center">Detail</div>,
			key: 'status',
			render: (_, record) => (
				<div className="text-center">
					<a type="primary" style={{ width: "70%" }} onClick={() => {
						history.push({
							pathname: '/app/detail-ticket',
							id: record._id,
						})
					}} >Update Jawaban</a>
				</div>
			),
		},
	];

	return (
		<>
			{title && (
				<Row gutter={24}>
				<Col xs={24} sm={24} md={24} lg={24}>
					<h2>Daftar Ticket</h2>
					<p>Summary analisa data aplikasi kali ini</p>
				</Col>
			</Row>
			)}
			<Row gutter={24}>
				<Col xs={24} sm={24} md={24} lg={24}>
					<Card title="Daftar Ticket Pertanyaan" >
						<Table
							className="no-border-last"
							columns={tableColumns}
							dataSource={list}
							rowKey='id'
							pagination={false}
						/>
					</Card>
				</Col>
			</Row>
		</>
	)
}


export default TICKET;
